import React, { useEffect } from 'react';

import Button from '@material-ui/core/Button';
import MicIcon from '../../../icons/MicIcon';
import MicOffIcon from '../../../icons/MicOffIcon';

import useLocalAudioToggle from '../../../hooks/useLocalAudioToggle/useLocalAudioToggle';
import useVideoContext from '../../../hooks/useVideoContext/useVideoContext';
import useChatContext from '../../../hooks/useChatContext/useChatContext';
import { LocalAudioTrack } from 'twilio-video';
import useParticipants from '../../../hooks/useParticipants/useParticipants';

export default function ToggleAudioButton(props: { disabled?: boolean; className?: string }) {
  const [isAudioEnabled, toggleAudioEnabled] = useLocalAudioToggle();
  const { localTracks, room } = useVideoContext();
  // const localParticipant = room!.localParticipant;
  const audioTrack = localTracks.find(track => track.kind === 'audio') as LocalAudioTrack;

  const hasAudioTrack = localTracks.some(track => track.kind === 'audio');
  const participants = useParticipants();
  const { messages } = useChatContext();

  useEffect(() => {
    //console.log(participants);
    //console.log(room?.localParticipant);
    if (messages.length > 0 && room?.localParticipant != null) {
      //console.log(messages[messages.length - 1]?.body?.split('/')[1], 'checking wala data');
      if (
        messages[messages.length - 1]?.body?.split('/')[0] == 'muted' &&
        messages[messages.length - 1]?.body?.split('/')[1] == room?.localParticipant.sid
      ) {
        toggleAudioEnabled();
      }
    }
  }, [messages]);
  return (
    <Button
      className={props.className}
      onClick={toggleAudioEnabled}
      disabled={!hasAudioTrack || props.disabled}
      startIcon={isAudioEnabled ? <MicIcon /> : <MicOffIcon />}
      data-cy-audio-toggle
    >
      <span className="formobs"> {!hasAudioTrack ? 'No Audio' : isAudioEnabled ? 'Mute' : 'Unmute'}</span>
    </Button>
  );
}
